export default __webpack_public_path__ + "static/media/truck-00-thumbnail.384f882e.jpg";